import React from "react";
import { TextField, Autocomplete } from "@mui/material";
import { useWarehouse } from "../contexts/WarehouseContext";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const WarehouseFilter = () => {
  const { warehouses, warehouseId, selectWarehouse } = useWarehouse();

  const handleWarehouseChange = (event) => {
    selectWarehouse(event.target.value);
  };

  if (warehouses && warehouses.length <= 1) {
    return;
  }
  return (
    <Autocomplete
      freeSolo
      value={
        warehouses.find((warehouse) => warehouse.id === warehouseId) || null
      }
      options={warehouses}
      getOptionLabel={(option) => option.name || ""}
      onChange={(event, value) => {
        if (value) {
          handleWarehouseChange({ target: { value: value.id } });
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          id="standard-basic"
          variant="standard"
          placeholder="Search Warehouse"
          sx={{ ...styles.textField, width: "200px" }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <SearchOutlinedIcon
                sx={{ marginLeft: "8px", marginRight: 1, color: "#d4d7db" }}
              />
            ),
          }}
        />
      )}
    />
  );
};

const styles = {
  textField: {
    background: "rgba(255, 255, 255, 0.24)",
    ".MuiInput-underline:before": {
      borderBottom: "none",
    },
    ".MuiInput-underline:hover:before": {
      borderBottom: "none",
    },
    ".MuiInput-underline:after": {
      borderBottom: "none",
    },
    borderRadius: "6px",
    "& .MuiInputBase-root": {
      paddingRight: "32px",
    },
    "& .MuiInputBase-input": {
      color: "white !important",
    },
  },
};
export default WarehouseFilter;
